import { render, staticRenderFns } from "./AuthorizationSuccess.vue?vue&type=template&id=64de89d6&scoped=true&"
import script from "./AuthorizationSuccess.vue?vue&type=script&lang=js&"
export * from "./AuthorizationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationSuccess.vue?vue&type=style&index=0&id=64de89d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64de89d6",
  null
  
)

export default component.exports